export class SurveyAnswer {
    user_id: string;
    question_survey_id: number;
    is_finished: boolean;
    answers_survey: any[];

    constructor(
        userId: string,
        questionSurveyId: number,
        isFinished: boolean,
        answersSurvey: any[]
    ) {
        this.user_id = userId;
        this.question_survey_id = questionSurveyId;
        this.is_finished = isFinished;
        this.answers_survey = answersSurvey;
    }
}
